import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../views/Sidebar/Sidebar";

const PrivateRoutes = () =>
{
	const auth = sessionStorage.getItem("loginToken") ? true : false;

	return (
		auth ? <><Sidebar /><Outlet /></> : <Navigate to={"/login"} />
	);
};

export default PrivateRoutes;